module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/mg-5bdc14fe1aa439d1a0b7bec9890f0ef8.svg";